const contactSecArr = document.querySelectorAll('.contact-sec');

if (contactSecArr.length) {
  contactSecArr.forEach((contactSec) => {
    const tabsWr = contactSec.querySelector('.contact-sec__form-tabs');
    const tabsArr = tabsWr ? tabsWr.querySelectorAll('.contact-sec__form-tab') : [];
    const itemsArr = contactSec.querySelectorAll('.contact-sec__item');
    const tabsCount = Math.min(tabsArr.length, itemsArr.length);
    let activeIndex = 0;
    let resizeFrame = null;

    if (!tabsWr || !tabsCount) {
      return;
    }

    const getInitialActiveIndex = () => {
      const activeTabIndex = [...tabsArr].findIndex((tab, idx) =>
        idx < tabsCount && tab.classList.contains('is-active')
      );

      if (activeTabIndex >= 0) {
        return activeTabIndex;
      }

      const activeItemIndex = [...itemsArr].findIndex((item, idx) =>
        idx < tabsCount && item.classList.contains('is-active')
      );

      return activeItemIndex >= 0 ? activeItemIndex : 0;
    };

    const moveBgToTab = (idx) => {
      const tab = tabsArr[idx];

      if (!tab) {
        return;
      }

      const tabsRect = tabsWr.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();

      tabsWr.style.setProperty('--contact-tab-bg-x', `${tabRect.left - tabsRect.left}px`);
      tabsWr.style.setProperty('--contact-tab-bg-y', `${tabRect.top - tabsRect.top}px`);
      tabsWr.style.setProperty('--contact-tab-bg-width', `${tabRect.width}px`);
      tabsWr.style.setProperty('--contact-tab-bg-height', `${tabRect.height}px`);
      tabsWr.classList.add('is-ready');
    };

    const setActiveTab = (idx) => {
      activeIndex = Math.max(0, Math.min(idx, tabsCount - 1));

      for (let i = 0; i < tabsCount; i++) {
        const isActive = i === activeIndex;

        tabsArr[i].classList.toggle('is-active', isActive);
        itemsArr[i].classList.toggle('is-active', isActive);
      }

      moveBgToTab(activeIndex);
    };

    const refreshActiveBg = () => {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(() => {
        moveBgToTab(activeIndex);
      });
    };

    tabsArr.forEach((tab, idx) => {
      if (idx >= tabsCount) {
        return;
      }

      tab.addEventListener('click', () => {
        setActiveTab(idx);
      });
    });

    activeIndex = getInitialActiveIndex();
    setActiveTab(activeIndex);
    window.addEventListener('resize', refreshActiveBg);
  });
}
